import { Badge } from "@libs/zapi-ui/shadcn";
import type { TClaudeRunStatus } from "../model/types";

const STYLES: Record<TClaudeRunStatus, string> = {
  pending: "bg-zinc-100 text-zinc-700",
  running: "bg-blue-50 text-blue-700",
  succeeded: "bg-green-50 text-green-800",
  failed: "bg-red-50 text-red-700",
  cancelled: "bg-amber-50 text-amber-800"
};

export function RunStatusBadge({ status }: { status: TClaudeRunStatus }) {
  return (
    <Badge
      variant="secondary"
      className={`rounded-[12px] capitalize whitespace-nowrap ${STYLES[status]}`}
      data-testid={`run-status-${status}`}
    >
      {status === "running" && <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-blue-500 animate-pulse" />}
      {status}
    </Badge>
  );
}
